import { Button } from "@loot-os/ui/components/button";
import { toast } from "@loot-os/ui/components/sonner";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "../lib/trpc";

/**
 * Sends a new image job for every row of the listing's product that needs one. A refusal or an
 * unsent job is the query client's toast; a send names how many jobs went out.
 */
export function ProcessImageAgainButton({ listingId }: { listingId: string }) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const processAgain = useMutation(
    trpc.platform.fulfillment.listings.processImageAgain.mutationOptions({
      onSuccess: ({ jobs, listings }) => {
        toast.success(
          `Sent ${jobs} image ${jobs === 1 ? "job" : "jobs"} for ${listings} ${listings === 1 ? "listing" : "listings"}.`,
        );
        void queryClient.invalidateQueries({
          queryKey: trpc.platform.fulfillment.listings.awaitingProcessedImage.queryKey(),
        });
      },
    }),
  );

  return (
    <Button
      size="sm"
      variant="outline"
      disabled={processAgain.isPending}
      onClick={() => processAgain.mutate({ id: listingId })}
    >
      {processAgain.isPending ? "Sending…" : "Process image again"}
    </Button>
  );
}
